import Decimal from "decimal.js";

import type { PSAAdapter } from "@/lib/adapters/base";
import type { CatalogKitConfig, NormalizedRow } from "@/types";

/**
 * Row filters mirroring the Python `core/filters.py`. Pure functions that take
 * and return arrays (a browser catalog comfortably fits in memory).
 */

/** Keep only the rows the adapter considers active. */
export function filterActive(rows: NormalizedRow[], adapter: PSAAdapter): NormalizedRow[] {
  return rows.filter((row) => adapter.isActive(row));
}

/** Keep rows whose price is non-zero, unless zero-price rows are explicitly kept. */
export function filterZeroPrice(rows: NormalizedRow[], includeZeroPrice: boolean): NormalizedRow[] {
  if (includeZeroPrice) return [...rows];
  return rows.filter((row) => !new Decimal(row.price).isZero());
}

/**
 * Apply the configured filters, preserving input order. Active filtering runs
 * first (when `filters.exclude_inactive` is set), then zero-price filtering
 * (governed by `filters.exclude_zero_price`).
 */
export function applyFilters(
  rows: NormalizedRow[],
  config: CatalogKitConfig,
  adapter: PSAAdapter,
): NormalizedRow[] {
  let result = rows;
  if (config.filters.exclude_inactive) {
    result = filterActive(result, adapter);
  }
  return filterZeroPrice(result, !config.filters.exclude_zero_price);
}
